
import Vue from 'vue';
import { faChevronUp, faChevronDown } from '@delfi.lt/fa-kit/icons/modules/classic/solid';

interface Data {
  faqs: any;
  isOpen: boolean;
  isMoreLoad: boolean;
  openQuestionIndex: number;
}

interface Methods {
  openQuestion: (index: number) => void;
  loadQuestion: () => void;
}

export default Vue.extend<Data, Methods, unknown>({
  data() {
    return {
      isOpen: false,
      isMoreLoad: false,
      openQuestionIndex: -1,
      faqs: [
        {
          question: 'Kaip tapti Delfi Lojalumo programos nariu?',
          answer: 'Norėdami tapti Delfi Lojalumo programos nariu, turite įsigyti Delfi prenumeratą.',
        },
        {
          question: 'Kiek laiko galioja Delfi Lojalumo programa?',
          answer:
            'Delfi Lojalumo programa galioja tiek, kiek turite aktyvią Delfi prenumeratą. Pasibaigus prenumeratai, programos privalumai ir naudos nebebus prieinami',
        },
        {
          question: 'Ar galiu dalintis Delfi Lojalumo programos pasiūlymais su kitais?',
          answer:
            'Prenumerata ir Lojalumo programos paskyra yra asmeninė, tačiau jeigu norite, galite perleisti paslaugą kitam darbuotojui (jei esate verslo prenumeratos naudotojas), susisiekdami su mūsų klientų aptarnavimo komanda.',
        },
        {
          question: 'Kaip sužinoti apie naujausius pasiūlymus ir akcijas Delfi Lojalumo programoje?',
          answer:
            'Visi naujausi pasiūlymai ir akcijos skelbiami Delfi programėlėje, mūsų interneto svetainėje, taip pat siunčiame informaciją el. paštu. Nepamirškite reguliariai tikrinti savo paskyros.',
        },
        {
          question: 'Kokie privalumai suteikiami dalyvaujant Delfi Lojalumo programoje?',
          answer:
            'Dalyvaujant Delfi Lojalumo programoje, nariai gali gauti specialius pasiūlymus, nuolaidas, prieigą prie išskirtinio turinio ir kitas privilegijas. Detalūs pasiūlymai ir naudos yra pateikiami Delfi Lojalumo programos puslapyje.',
        },
        {
          question: 'Kaip galiu atnaujinti savo Delfi prenumeratą ir pratęsti dalyvavimą Lojalumo programoje?',
          answer:
            'Norėdami atnaujinti savo Delfi prenumeratą ir pratęsti dalyvavimą Lojalumo programoje, tiesiog prisijunkite prie savo Delfi paskyros ir pasirinkite norimą prenumeratos planą.  Po prenumeratos atnaujinimo, jūsų dalyvavimas Lojalumo programoje bus pratęstas ir galėsite toliau naudotis visais programos privalumais.',
        },
        {
          question: 'Kur galiu gauti pagalbą dėl Delfi Lojalumo programos?',
          answer:
            'Jei turite klausimų ar reikia pagalbos, susisiekite su mūsų klientų aptarnavimo komanda el. paštu prenumerata@delfi.lt arba telefonu +370 624 97793 .',
        },
      ],
      faChevronUp,
      faChevronDown,
    };
  },
  methods: {
    openQuestion(index: number) {
      if (this.openQuestionIndex === index) {
        this.isOpen = !this.isOpen;
      } else {
        this.isOpen = true;
      }
      this.openQuestionIndex = index;
    },
    loadQuestion() {
      this.isMoreLoad = !this.isMoreLoad;
    },
  },
});
